<script setup>
import {useSystem} from "../../store/system";
import {useProducts} from "../../store/products";
import {onActivated, onMounted, ref, watch} from "vue";
import {useRouter} from "vue-router";

const router = useRouter()
const systemStore = useSystem()

const productStore = useProducts()
productStore.productsListApi()

const tempColors = []
const colorEqule = () => {
  if (tempColors.length % 2 === 0) {
    let color = systemStore.getRandomColor()
    tempColors.push("stats__dodger--" + color)
  }else{
    tempColors.push(tempColors[tempColors.length-1])
  }
  return tempColors[tempColors.length-1]
}

onActivated(() => {
  document.title = 'High-Return Cloud Mining Plans | No Investment Bitcoin Mining';
  document.querySelector('meta[name="description"]').setAttribute('content', 'Choose from HexMiner’s best cloud mining contracts. Start\n' +
      'passive income crypto mining with flexible plans & free trials.');
})

</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12">
            <div class="section__title">
              <h1>{{systemStore.getFrontModuleContent(3)?.title}}</h1>
<!--              <p>More features with own Centure token.</p>-->
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- products -->
    <section class="section">
      <div class="container">

        <el-row :gutter="30">
          <el-col :span="24" :md="8" v-for="(item, index) in productStore.getProductsList" :key="index">
            <div class="feature h-auto py-5 text-white" style="font-family: 'Manrope', sans-serif;">
              <el-image class="tw-w-[4.5rem] tw-h-[4.5rem] tw-mb-3 tw-rounded-full" fit="cover" :src="item.image? item.image: 'img/logo.svg'"></el-image>
              <h3 class="feature__title">{{item.name}}</h3>
              <p class="tw-font-bold tw-text-[1.3rem]">$ {{parseFloat(item.amount)}}</p>

              <!--              固定-->
              <div v-if="item.profit_type == 1" class="tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Daily Rewards</div>
                <div>$ {{parseFloat(item.fixed_profit)}}</div>
              </div>
              <!--              百分比-->
              <div v-if="item.profit_type == 2" class="tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Daily Rewards</div>
                <div>$ {{parseFloat(item.amount) * parseFloat(item.percent_profit)}}</div>
              </div>

              <div class="tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Total Earnings</div>
                <div>$ {{parseFloat(item.expected_profit)}}</div>
              </div>

              <div class="tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Matured Amount</div>
                <div>$ {{parseFloat(item.amount)}} + $ {{parseFloat(item.expected_profit)}}</div>
              </div>

              <div class="tw-mt-2 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Contract Duration</div>
                <div>{{item.products_day}} Day</div>
              </div>

              <div class="tw-mt-4 tw-flex tw-justify-between tw-items-center feature__text tw-w-full">
                <div>Principal Refund </div>
                <div v-if="item.return_capital == 1">Yes</div>
                <div v-else>No</div>
              </div>


              <button class="section__btn tw-mt-10" type="button" @click="router.push({path:'/ProductDetail', query:{id: item.products_id}})">Invest Now</button>
              <!--              <div class="section__btns section__btns&#45;&#45;two">-->
              <!--                <a href="faq.html" class="section__btn">Alle ansehen</a>-->
              <!--                <button class="section__btn section__btn&#45;&#45;light" data-bs-toggle="modal" data-bs-target="#modal-ask" type="button">Eine Frage stellen</button>-->
              <!--              </div>-->

              <!-- design elements -->
              <span class="block-icon" :class="systemStore.getBlockIconColor()">
							  <i class="ti ti-mood-dollar"></i>
						  </span>
              <span class="screw screw--bl"></span>
              <span class="screw screw--tr"></span>
              <span class="screw screw--big-br"></span>
            </div>
          </el-col>
<!--          <el-col :span="24">-->
<!--            <button class="justify-self-center mt-5 section__btn section__btn&#45;&#45;light" type="button">Load More <i class="ti ti-arrow-move-right ml-2 text-[28px]"></i></button>-->
<!--          </el-col>-->
        </el-row>

      </div>
    </section>
    <!-- end products -->

    <section class="section">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="roadmap tw-mt-4 tw-rounded-md card-bg-active !tw-justify-between" style="align-items: normal !important;">
              <el-row class="w-full">
                <el-col :span="24" :md="18">
                  <div class="tw-text-[2rem] tw-font-bold">{{systemStore.getFrontModuleContent(25).title}}</div>
                  <div>{{systemStore.getFrontModuleContent(25).sub_title}}</div>
                </el-col>
                <el-col :span="24" :md="6" class="tw-content-center">
                  <button class="section__btn xs:tw-justify-self-center sm:tw-justify-self-end xs:tw-mt-5 md:tw-mt-0" type="button" @click="router.push({path:'/Dashboard'})">{{systemStore.getFrontModuleContent(25).description}}</button>
                </el-col>
              </el-row>

              <!-- design elements -->
              <span class="block-icon block-icon--purple">
							  <i class="ti ti-topology-star-ring"></i>
						  </span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<style scoped>

</style>
